import { render } from "./Organisator.vue?vue&type=template&id=14a35ca6&scoped=true"
import script from "./Organisator.vue?vue&type=script&lang=js"
export * from "./Organisator.vue?vue&type=script&lang=js"

import "./Organisator.vue?vue&type=style&index=0&id=14a35ca6&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a35ca6"]])

export default __exports__